<!--客户管理-客户列表 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea CProductSales">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 查询框 -->
        <div class="queryBox clearfix">
          <el-input class="dateInput w220" v-model="keyword.device_no_id" placeholder="请输入设备ID" clearable @change="getOutStockList(1)"></el-input>
          <el-input class="dateInput w220" v-model="keyword.company_name" placeholder="请输入所属企业" clearable @change="getOutStockList(1)"></el-input>
          <el-cascader
            v-model="keyword.device_id"
            :options="keyword.typeList"
            :show-all-levels="false"
            :props="cascProps"
            @change="getOutStockList(1)"
            clearable>
          </el-cascader>
          <el-button class="queryBtn" type="primary" @click="getOutStockList(1)">查 询</el-button>
        </div>
        <!-- 按钮区域 -->
        <div class="btnArea clearfix">
          <el-button class="batchRecycleBtn" @click="openDistri('1')">批量分配</el-button>
          <!-- <el-button class="viewLogBtn" @click="viewLog">查看日志</el-button> -->
        </div>
        <!-- 已出库列表 -->
        <el-table ref="hasOutput" v-loading="loading" :data="salesList" style="width: 100%" @selection-change="hasOutputSelectionChange" :cell-style="hasOutputSetCellStyle">
          <el-table-column type="selection" width="55" :selectable="unChecked"></el-table-column>
          <el-table-column prop="device_no_id" label="设备ID" sortable></el-table-column>
          <el-table-column prop="device_type" label="设备类型" sortable></el-table-column>
          <el-table-column prop="company_name" label="所属企业" sortable></el-table-column>
          <el-table-column label="设备状态" sortable prop="online">
            <template slot-scope="scope">
              <span v-if="scope.row.online == true" style="color:#67C23A">在线</span>
              <span v-else style="color:#F56C6C">离线</span>
            </template>
          </el-table-column>
          <el-table-column label="激活状态" sortable prop="is_activation">
            <template slot-scope="scope">
              <span v-if="scope.row.is_activation == '0'" style="color:#67C23A">未激活</span>
              <span v-else style="color:#F56C6C">已激活</span>
            </template>
          </el-table-column>
          <el-table-column prop="out_stock_time" label="出库时间" sortable></el-table-column>
          <el-table-column label="操作" class-name="operate">
            <template slot-scope="scope">
              <div class="toolDiv" v-if="scope.row.is_activation == '1'">
                <el-tooltip class="item" effect="dark" content="该设备已被激活，重新分配必须到设备端初始化设备" placement="left">
                  <el-button type="text">分配</el-button>
                </el-tooltip>
              </div>
              <el-button type="text" @click="openDistri('2',scope.$index)" v-else>分配</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="paging" v-if="pageCount>1">
          <el-pagination
            @current-change="hasOutputPageChange"
            :current-page.sync="curr"
            layout="prev, pager, next, jumper"
            :page-count="pageCount">
          </el-pagination>
        </div>
      </div>
      <el-dialog title="分配设备" :visible.sync="distriDio" width="480px">
        <div class="contDio">
          <el-form ref="form" :model="distform" label-width="90px" :rules="rules">
            <el-form-item label="企业名称" prop="companyId">
              <el-select class="db" v-model="distform.companyId" filterable placeholder="请选择公司名称">
                <el-option
                  v-for="item in compList"
                  :key="item.company_id"
                  :label="item.company_desc"
                  :value="item.company_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="distriDio = false">取 消</el-button>
          <el-button type="primary" @click="submitDist('form')">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { 
      showToast,
      showLoading,
      hideLoading,
      deepCopy
    } from "../../../../static/js/utility/utility.js"
  import { clientMApi } from "../../../../static/js/api.js"
  import { commomHeaders } from "../../../../static/js/config.js"

  export default {
    name: 'CProductSales',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        //关键搜索
        keyword:{
          device_no_id:'',
          device_id:[],
          company_name:'',
          typeList:[],
        },
        cascProps:{
          value:'device_id',
          label:'name',
          children:'children'
        },

        salesList:[],
        loading: false,
        selection:[],//选中

        curr:1,
        limits:10,
        pageCount:0,

        distriDio:false,
        distform:{
          type:'',//1是批量，2是单个
          deviceId:[],
          companyId:''
        },
        compList:[],
        rules: {
          companyId: [
            { required: true, message: '请选择分配公司', trigger: 'blur' },
          ],
        },
      }
    },
    created: async function () {
      this.getDeviceType()
      this.getOutStockList()
    },
    mounted(){
      
    },
    methods: {
      //提交分配验证
      submitDist(formName){
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.editStock()
          } else {return false;}
        });
      },
      //分配公司
      async editStock(){
        let that = this;
        // console.log(that.distform)
        const dataObj ={
          // 'device_no_id': that.distform.deviceId,
          'company_id': that.distform.companyId
        }
        if(that.distform.type=='1'){
          dataObj.device_no_id=that.distform.deviceId
        }else{
          dataObj.device_no_id=that.distform.deviceId[that.distform.deviceId.length-1]
        }
        const res = await clientMApi.editStock(dataObj)
        if(res.meta.code == 200){
          showToast('分配成功！')
          that.distform={
            type:'',
            deviceId:[],
            companyId:''
          }
          that.distriDio = false;
          that.getOutStockList(1)
        }else{
         that.compList=[]
          showToast(res.meta.message)
        }
      },
      // 已出库列表 - 设置单元格样式
      hasOutputSetCellStyle: function ({row, column, rowIndex, columnIndex}) {
        if (row.is_activation=='1') {
          return {color: '#cccccc'}
        } else {
          return {}
        }
      },
      // 禁选 
      unChecked: function (row, index) {
        // 判断是否状态为已出库，如果已出库就不能选择
        if (row.is_activation === '1') {
          return 0
        }else{
          return 1
        }
      },
      //打开分配
      openDistri(type,index){
        if(type=='1'){
          if(this.selection==''){
            showToast('请先选择需要分配的设备')
            return
          }else{
            this.distform.deviceId = this.selection
            this.distform.type='1'
          }
        }else{
          this.distform.deviceId.push(this.salesList[index].device_no_id)
          this.distform.type='2'
        }
        this.getClientList()
        this.distriDio = true;
      },
      //获取公司列表
      async getClientList(){
        let that = this;
        const res = await clientMApi.getCompanyAllClient()
        if(res.meta.code == 200){
          that.compList = res.data.list
        }else{
         that.compList=[]
          showToast(res.meta.message)
        }
      },
      //获取设备列表
      async getDeviceType(){
        let that = this;
        const res = await clientMApi.getDeviceType()
        if(res.meta.code == 200){
          that.keyword.typeList = res.data
        }else{
          that.keyword.typeList=[]
          showToast(res.meta.message)
        }
      },
      //获取产品销售列表
      async getOutStockList(curr,limits){
        let that = this;
        this.loading = true
        const dataObj = {
          'page':curr?curr:that.curr,
          'perPage':limits?limits:that.limits,
          'device_no_id':that.keyword.device_no_id,
          'device_id': that.keyword.device_id[that.keyword.device_id.length-1],
          'company_name': that.keyword.company_name,
        }
        const res = await clientMApi.getOutStockList(dataObj)
        if(res.meta.code == 200){
          that.salesList = res.data.list
          that.pageCount = res.data.pageCount
          that.loading=false
        }else{
          that.salesList=[]
          that.loading=false
          showToast(res.meta.message)
        }
      },
      // 翻页
      hasOutputPageChange(val) {
        // console.log(`当前页: ${val}`);
        this.getOutStockList(val)
      },
      // checkBox ---监听用户是否选中未入库列表
      hasOutputSelectionChange(val) {
        this.selection=[]
        for (let i in val) {
          this.selection.push(val[i].device_no_id)
        }
      },

      
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CProductSales{
  .w220{ width: 220px; margin-right: 20px;}
  .queryBox{
    margin-bottom: 20px;
  }
  .db{
    display: block;
  }
  .toolDiv{
    .el-button{
      color: #ccc;
    }
  }
}
.el-tooltip__popper{
  width: 200px;
  padding: 8px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CCustomer/CProductSales.vue